export const navigationLinks = [
  { name: "Proximity Labs", url: "https://proximity.tech" },
  { name: "Blog", url: "https://blog.proximity.tech" },
  { name: "Contact us", url: "https://www.proximity.tech/contact" },
  { name: "Login", url: "/login" },
];
